import { render, staticRenderFns } from "./PerformanceReviewItemList.vue?vue&type=template&id=3613d804&"
import script from "./PerformanceReviewItemList.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports